import React from "react";
import "./InputCheckbox.scss";

type InputCheckboxProps = {
    name?: string;
    id: string;
    label?: string;
    checked?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    spacing?: string;
    align?: "flex-start" | "center" | "flex-end" | "space-between";
    onlyCheckbox?: boolean;
    required?: boolean;
    className?: string;
};

const InputCheckbox: React.FC<InputCheckboxProps> = ({
    name,
    id,
    label,
    checked = false,
    onChange,
    spacing = "12px",
    align = "flex-start",
    onlyCheckbox = false,
    required = false,
    className = "",
}) => {
    const containerStyle =
        align === "space-between" ? { justifyContent: "space-between" } : {};

    return (
        <div
            className={`input-checkbox ${onlyCheckbox ? "only-checkbox" : ""}`}
            style={containerStyle}
        >
            <input
                name={name}
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                required={required}
                className={`input-checkbox__input ${className}`}
            />
            <div
                className={`input-checkbox__box ${
                    checked ? "input-checkbox__box--checked" : ""
                }`}
            ></div>
            {!onlyCheckbox && label && (
                <label
                    htmlFor={id}
                    className="input-checkbox__label"
                    style={{
                        marginLeft: align !== "space-between" ? spacing : "0",
                    }}
                >
                    {required && <span className="input-dropdown__required">*</span>}
                    {label}
                </label>
            )}
        </div>
    );
};

export default InputCheckbox;
